<template>
  <div>
    <div class="pa-t-40 bg-red">
      <div class="t-center c-fff fon-26">感谢您的支持，让项目筹资总金额达到 {{projectData.GetAmount}}元</div>
      <div class="flex  f-center qr-wrap f-jcenter c-fff">
        <img src="../../img/qrcode.png" alt="" srcset="" class="ma-r-20">
        关注SHISU官方公众号，了解回报详情！
      </div>
    </div>
    <div class="container ma-t-80 ma-b-30">
      <div class="flex f-between bg-ff bg-fff pa-t-20 pa-b-30">
        <div class="width50">
          <div class="pa-30">
            <div>分享给更多朋友！</div>
            <div class="flex f-jcenter width100 ma-t-20">
              <div class="share-icon" @click="copyToClip()" title="复制链接">
                <i class="iconfont icon-lianjie"></i>
              </div>
              <div class="share-icon ma-lr-20" @click="shareQQ()" title="分享到QQ空间">
                <i class="iconfont icon-qqkongjian"></i>
              </div>
              <div class="share-icon" @click="shareWEB()" title="分享到微博">
                <i class="iconfont icon-weibo"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="width50">
          <div class="pa-r-30">
            <div class="c-red fon-22"> {{projectData.Name}}</div>
            <div>回报档：{{amountData.Price}}元</div>
            <div>支持金额：{{Amount}}元</div>
            <div>您的回报：{{amountData.Summary}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCrowdFundingDetail } from "../../api.js";
export default {
  data() {
    return {
      amountData: {},
      projectData:{},
      amountId:'',
      projectId:'',

      Amount:'',//支持金额
    };
  },
  activated() {
    if(this.$route.query.amountId!=this.amountId || this.$route.query.projectId!=this.projectId){
        this.amountId = this.$route.query.amountId;
        this.projectId = this.$route.query.projectId;

        this.Amount = this.$route.query.Amount;
        this.loadData()
    }
    
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },
  methods: {
    //获取众筹信息
    loadData(){
        getCrowdFundingDetail({id: this.projectId}).then(res=>{
            this.projectData = res.data.Data;
            this.amountData= this.projectData.AmountList.find(item=>{
                if(item.Id==this.amountId){
                    return item
                }
            })
        })
    },
  },
};
</script>

<style  lang="scss" scoped>

.share-icon {
  width: 40px;
  height: 40px;
  background: #8a8a8a;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  color: #fff;
  cursor: pointer;
}
.bg-red {
  background: #fb004d;
}

.qr-wrap {
  position: relative;
  bottom: -40px;
  img {
    width: 130px;
  }
}
</style>